import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { DefaultAndValue, restore2 } from "./restore";
import { useFlyerConfig } from "./useFlyerConfig";


export const v = (valueAndDefault) => {
  if (typeof valueAndDefault === 'string') {
    return valueAndDefault;
  }
  return valueAndDefault['value'];
}

export const useRestorable = (
  defaultValue: string,
  key: string,
  keyHasConfig: boolean = false
): [DefaultAndValue, Dispatch<SetStateAction<DefaultAndValue>>] => {
  const [value, setter] = useState<DefaultAndValue>({
    default: defaultValue,
    value: defaultValue
  });
  const keyWithConfig = (() => {
    if (keyHasConfig === true) {
      return key;
    } else {
      const { flyerType, flyerLocale } = useFlyerConfig();
      return `${flyerType}:${flyerLocale}:${key}`;
    }
  })();
  const setterWithStorage = (newValue) => {
    if (typeof newValue === 'string') {
      console.log("useRestorable setter with wrong type (pure string)")
    } else if (typeof newValue === 'object' && newValue !== null && 'default' in newValue && 'value' in newValue) {
      setter(newValue);
      localStorage.setItem(keyWithConfig, newValue["value"]);
    }
  }
  
  useEffect(() => {
    restore2(keyWithConfig, defaultValue, setter)
  }, []);
  return [value, setterWithStorage];
}